var map = {
	"./1.svg": 2119,
	"./2.svg": 2120,
	"./3.svg": 2121,
	"./4.svg": 2122,
	"./5.svg": 2123,
	"./6.svg": 2124,
	"./7.svg": 2125,
	"./8.svg": 2126,
	"./check.svg": 83,
	"./dot.svg": 84,
	"./hcf_logo.svg": 2127,
	"./logo-hcf.svg": 97,
	"./logo-mkm-dark.svg": 100,
	"./logo-mkm.svg": 80,
	"./pattern.svg": 52
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2118;